module.exports = __webpack_public_path__ + "img/skiing_1413_4.cb41b778.jpg";